import { createFileRoute } from '@tanstack/react-router';
import { DocumentsIndexList } from '@/features/portal/documents/DocumentsIndexList.tsx';

export const Route = createFileRoute('/portal/documents/')({
  head: () => ({ meta: [{ title: 'Documents' }] }),
  component: DocumentsIndexList,
});
